module.exports = __webpack_public_path__ + "assets/img/page3-design-side-nav-expanded-4-16c4fbcb.png";